module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-qoro-corian-all.1d23a930.jpg";